import { TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import {
  Bagde,
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import usePrevious from "libs/hooks/usePrevious";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

export default function JobSection({
  colSpan = 6,
  bagdeStart = 19,
  formik,
  prefixFieldName = "",
}) {
  const classes = useStyles();
  const masterData = useSelector(selectMasterData);

  const jobPositionConfig = get(masterData, "jobPositionConfig", []);

  const prevJobPosition = usePrevious(formik.values.JobPosition);
  const isJobPositionChange =
    prevJobPosition && prevJobPosition !== formik.values.JobPosition;
  const canEdit = useSelector(canEditForm);
  useEffect(() => {
    if (isJobPositionChange) {
      formik.setFieldValue("JobSubPosition", "");
    }
  }, [formik, isJobPositionChange]);

  const index = 0;
  const jobTable = get(
    formik.values,
    `${prefixFieldName ? `${prefixFieldName}.` : ""}JobTable.${index}`,
    {}
  );
  const jobSubPositionConfig =
    jobPositionConfig.find((job) => job.jobID === jobTable.jobID)
      ?.jobSubPosition || [];

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div
              className={classes.flexRow}
              style={{ flex: 1, display: "flex" }}
            >
              <Bagde number={bagdeStart} />
              <InputLabel>Job position</InputLabel>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginLeft: 16, flex: 1 }}
              >
                <InputLabel>Select Job position</InputLabel>
                <Select
                  disabled={!canEdit}
                  label="Select Job position"
                  name={`${prefixFieldName ? `${prefixFieldName}.` : ""
                    }JobTable.${index}.jobID`}
                  defaultValue=""
                  value={get(
                    formik.values,
                    `${prefixFieldName ? `${prefixFieldName}.` : ""
                    }JobTable.${index}.jobID`,
                    ""
                  )}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {jobPositionConfig.map((jobPosition) => (
                    <MenuItem key={jobPosition.jobID} value={jobPosition.jobID}>
                      {jobPosition.jobName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginLeft: 16, flex: 1 }}
              >
                <InputLabel>Select Job Sub position</InputLabel>
                <Select
                  disabled={!canEdit}
                  label="Select Job Sub position"
                  name={`${prefixFieldName ? `${prefixFieldName}.` : ""
                    }JobTable.${index}.jobsubID`}
                  defaultValue=""
                  value={get(
                    formik.values,
                    `${prefixFieldName ? `${prefixFieldName}.` : ""
                    }JobTable.${index}.jobsubID`,
                    ""
                  )}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {jobSubPositionConfig.map((jobPosition) => (
                    <MenuItem
                      key={jobPosition.jobsubID}
                      value={jobPosition.jobsubID}
                    >
                      {jobPosition.jobsubName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <Bagde number={bagdeStart + 1} />
            <div className={classes.wrapField}>
              <InputLabel style={{ width: 90 }}>Job Title</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name={`${prefixFieldName ? `${prefixFieldName}.` : ""
                  }JobTable.${index}.jobTitle`}
                value={get(
                  formik.values,
                  `${prefixFieldName ? `${prefixFieldName}.` : ""
                  }JobTable.${index}.jobTitle`,
                  ""
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  `${prefixFieldName ? `${prefixFieldName}.` : ""
                  }JobTable.${index}.jobTitle`,
                  formik
                )}
                helperText={getErrorMessage(
                  `${prefixFieldName ? `${prefixFieldName}.` : ""
                  }JobTable.${index}.jobTitle`,
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <Bagde number={bagdeStart + 2} />
            <div className={classes.wrapField}>
              <InputLabel>Job description</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name={`${prefixFieldName ? `${prefixFieldName}.` : ""
                  }JobTable.${index}.jobDesc`}
                value={get(
                  formik.values,
                  `${prefixFieldName ? `${prefixFieldName}.` : ""
                  }JobTable.${index}.jobDesc`,
                  ""
                )}
                error={isError(
                  `${prefixFieldName ? `${prefixFieldName}.` : ""
                  }JobTable.${index}.jobDesc`,
                  formik
                )}
                helperText={getErrorMessage(
                  `${prefixFieldName ? `${prefixFieldName}.` : ""
                  }JobTable.${index}.jobDesc`,
                  formik
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                multiline
                rows={5}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
